import React from 'react';
import { Link as ScrollLink } from 'react-scroll';

const Banner = () => {
  return (
    <section id="banner">
      <div className="content">
        <header>
          <h2>Soares de Miranda e André, Lda.</h2>
          <p>CONSTRUÇÕES</p>
        </header>
        <span className="image"><img src="images/miranda.jpg" alt="" /></span>
      </div>
      <ScrollLink activeClass="active" className="goto-next scrolly" to="about" spy={true} smooth={true} offset={0}
        duration={500}>
        Next
      </ScrollLink>
    </section>
  )
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/banner/Banner.js